import script from "./AiFollowUpAssistantConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./AiFollowUpAssistantConfig.vue?vue&type=script&setup=true&lang=js"

import "./AiFollowUpAssistantConfig.vue?vue&type=style&index=0&id=33df6841&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33df6841"]])

export default __exports__